import { types } from "../action-types";

const initialState = {
  loading: false,
  followers: [],
  error: false,
};

const getFollowersReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_FOLLOWERS_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case types.GET_FOLLOWERS_SUCCESS:
      return {
        ...state,
        loading: false,
        followers: action.payload,
        error: false,
      };
    case types.GET_FOLLOWERS_FAILURE:
      return {
        ...state,
        loading: false,
        followers: [],
        error: true,
      };
    default:
      return state;
  }
};

export default getFollowersReducer;
